import * as environments from 'src/environments.json';
const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const downloadFile = async (url) => {
  url = `${env.api.url.replace('/api/v1', '')}${url}`;

  window.location = url;
};

export default downloadFile;
